import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Title, Meta } from '@angular/platform-browser';
import { SeoService } from './services/seo.service';
import { VisitorCounterService } from './services/visitor-counter/visitor-counter.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;

    constructor(
        private router: Router,
        private titleService: Title,
        private metaService: Meta,
        private seoService: SeoService,
        private activatedRoute: ActivatedRoute,
        private visitorCounterService: VisitorCounterService
    ) {
    }

    ngOnInit(){
        this.recallJsFuntions();
        this.setUpTitleUpdater();
        // Initialize visitor counter
        this.visitorCounterService.updateVisitorRecord();
    }

    recallJsFuntions() {
        this.router.events
        .subscribe((event) => {
            if ( event instanceof NavigationStart ) {
                $('.preloader').fadeIn('slow');
            }
        });
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            $.getScript('assets/js/custom.js');
            $('.preloader').fadeOut('slow');
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            // Update visitor count on navigation
            this.visitorCounterService.updateVisitorRecord();
            window.scrollTo(0, 0);
        });
    }

    setUpTitleUpdater() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            let route = this.activatedRoute;
            while (route.firstChild) {
                route = route.firstChild;
            }
            route.data.subscribe(data => {
                let title = data.title ? `${data.title} - Insightful IT Services` : 'Insightful IT Services - Cloud & Managed IT Services in India | Enterprise Solutions';
                
                // Set meta description based on page
                let description = 'Leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure, 24/7 support, 99.9% uptime SLA.';
                let keywords = 'Cloud Services India, Managed IT Services India, Windows Cloud Hosting, Linux Cloud Hosting, GPU Cloud Computing, Enterprise Cloud Solutions';
                
                // Customize description and keywords based on page
                if (data.title) {
                    switch(data.title.toLowerCase()) {
                        case 'managed it services':
                            description = 'Professional Managed IT Services in India with 24/7 support, 99.9% uptime SLA, cybersecurity, backup & recovery, and network management. Enterprise-grade solutions.';
                            keywords = 'Managed IT Services India, IT Support India, 24/7 IT Support, IT Management Services, Cybersecurity India, Network Management, Backup & Recovery, Cloud Infrastructure';
                            break;
                        case 'windows cloud':
                            description = 'Premium Windows Cloud Hosting in India with high-performance virtual machines, scalable resources, and enterprise-grade security. Perfect for businesses of all sizes.';
                            keywords = 'Windows Cloud Hosting India, Windows VPS India, Cloud Windows Server, Virtual Windows Machine, Enterprise Cloud Solutions, Scalable Cloud Hosting';
                            break;
                        case 'gpu cloud computing':
                            description = 'High-performance GPU Cloud Computing services in India for AI, machine learning, rendering, and scientific computing. Scalable GPU resources with enterprise support.';
                            keywords = 'GPU Cloud Computing India, GPU VPS India, AI Cloud Services, Machine Learning Cloud, Rendering Cloud, Scientific Computing Cloud';
                            break;
                        case 'cloud infrastructure':
                            description = 'Enterprise Cloud Infrastructure solutions in India with scalable resources, high availability, and robust security. Build and deploy applications with confidence.';
                            keywords = 'Cloud Infrastructure India, Enterprise Cloud Solutions, Scalable Cloud Resources, High Availability Cloud, Secure Cloud Infrastructure';
                            break;
                        case 'cybersecurity':
                            description = 'Comprehensive Cybersecurity Solutions in India including threat detection, vulnerability assessment, and security monitoring. Protect your business from cyber threats.';
                            keywords = 'Cybersecurity Services India, Threat Detection India, Security Monitoring, Vulnerability Assessment, Data Protection, Network Security';
                            break;
                        case 'backup as a service':
                            description = 'Professional Backup As A Service solutions in India powered by Veeam Backup Agent with automated data protection, disaster recovery, and business continuity planning. Ensure your critical data is always safe and recoverable.';
                            keywords = 'Backup As A Service India, Veeam Backup Agent, Data Backup Solutions, Disaster Recovery, Automated Backups, Business Continuity, Cloud Backup';
                            break;
                        case 'network management':
                            description = 'Professional Network Management Services in India with monitoring, optimization, and troubleshooting. Ensure optimal network performance and security.';
                            keywords = 'Network Management India, Network Monitoring, Network Optimization, Network Security, Network Troubleshooting, Enterprise Network Services';
                            break;
                        case 'pricing':
                            description = 'Transparent and competitive pricing for Cloud Services and Managed IT Solutions in India. Flexible plans for businesses of all sizes with no hidden costs.';
                            keywords = 'Cloud Hosting Pricing India, Managed IT Pricing, IT Services Cost, Cloud Infrastructure Pricing, Enterprise IT Solutions Pricing';
                            break;
                        case 'about':
                            description = 'Insightful IT Services is a leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure with 24/7 support.';
                            keywords = 'Insightful IT Services, Cloud Provider India, Managed IT Company, Enterprise IT Solutions, IT Services Provider India';
                            break;
                        case 'contact':
                            description = 'Contact Insightful IT Services for Cloud Services and Managed IT Solutions in India. Our experts are ready to help with your IT infrastructure needs.';
                            keywords = 'Contact IT Services India, Cloud Support India, Managed IT Support, IT Consultation, Enterprise IT Services Contact';
                            break;
                        default:
                            description = 'Leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure, 24/7 support, 99.9% uptime SLA. Specializing in Windows Cloud, Linux Cloud, GPU Cloud, and comprehensive managed IT services.';
                            keywords = 'Cloud Services India, Managed IT Services India, Windows Cloud Hosting, Linux Cloud Hosting, GPU Cloud Computing, Enterprise Cloud Solutions, Cloud Infrastructure India, Managed IT Support';
                    }
                }
                
                // Use SEO service to update all tags with URL
                const url = `https://www.insightfulitservices.com${event.url}`;
                this.seoService.setSEOTagsWithUrl(data.title || 'Home', description, keywords, url);
            });
        });
    }
}